/**
 * This enum describes the state of the progress of a student regarding an
 * activity or objective. Unopened means the activity/objective is inaccessible,
 * opened that it is accessible, and closed that it is finished.
 */
export var OpeningState;
(function (OpeningState) {
    OpeningState[OpeningState["Unopened"] = 0] = "Unopened";
    OpeningState[OpeningState["Opened"] = 1] = "Opened";
    OpeningState[OpeningState["Closed"] = 2] = "Closed";
})(OpeningState || (OpeningState = {}));
export var AIEnginesIDs;
(function (AIEnginesIDs) {
    AIEnginesIDs["zpdes"] = "zpdes";
    AIEnginesIDs["adaptiveTest"] = "adaptiveTest";
    AIEnginesIDs["revisionAlg"] = "revisionAlg";
    AIEnginesIDs["cnedAdaptiveTest"] = "cnedAdaptiveTest";
})(AIEnginesIDs || (AIEnginesIDs = {}));
export var AIAgentsIDs;
(function (AIAgentsIDs) {
    AIAgentsIDs["studentActivityMonitorAgent"] = "studentActivityMonitorAgent";
    AIAgentsIDs["messageManegementAgent"] = "messageManegementAgent";
    AIAgentsIDs["eventButler"] = "eventButler";
})(AIAgentsIDs || (AIAgentsIDs = {}));
//# sourceMappingURL=interfaces.js.map